<div class="sidebar-container export-settings">
  @if (saving$ | async) {
    <app-loading [size]="'3x'"></app-loading>
  }
  <div class="pane-form">
    @if (formProperties.length > 0) {
      <app-dynamic-form
        #dynamicForm
        [formProperties]="formProperties"
        [formGroup]="formGroup"
        [fieldFilterString]="searchString"
        [style.height]="'100%'"
      ></app-dynamic-form>
    }
  </div>
</div>
